import { LogoLiftmee } from './LogoLiftmee'

export default LogoLiftmee
